import React, { memo, ReactNode } from "react";
import { Box } from "@UI/Components/Box/Box";

interface IMetricProgressFooter {
  text: ReactNode;
}

export const MetricProgressFooter = memo(({ text }: IMetricProgressFooter) => (
  <Box fontSize="sm" color="gray.500">
    {text}
  </Box>
));

MetricProgressFooter.displayName = "MetricProgressFooter";
